import React, { useState, Fragment} from "react";

import { apiCall } from "../../../functions/utils";
import {
  Row,
  Button,
  Card,
  CardBody,
  CardTitle,
  InputGroup,
  InputGroupAddon,
  Input,
  CustomInput,
  UncontrolledDropdown
} from "reactstrap";


export default function ImportContacts(){
    const [state,setState]=useState({
        selectedFile:false,
        isLoading:true
    })
  
    const fileCapture = event => {
        console.log(event.target.files[0])
        setState({
            selectedFile: event.target.files[0]
        })
    }
    const uploadCSV = async () => {
        let {selectedFile} = state
    
        if( selectedFile ){
          setState({isLoading: false});
          var form = new FormData()
          form.append('file', selectedFile )


          const response = await apiCall(true, "POST", `/api/contacts/bulk-store`, form, false, true)
          if( response ){
            setState({isLoading: true});
              alert(response.data.message+ ": " +response.data.success_count+ " successfull, " +response.data.error_count+ " failed" );
              window.location.href = '/contacts';
          }else{
            // console.error("CSV Upload Error",err);
            setState({isLoading: true});
            alert("Error. only csv file is allowed and phone number is must.");
          }
          
        }
        
      }
    
        let {isLoading} = state
        return true ? (
            <Fragment>
           
            <Card className="mb-4 mt-4">
                <CardBody>
                    <CardTitle>
                        Instructions
                    </CardTitle>
                    <p>
                        When uploading your contact list, please make sure that the csv file contains the following headings; "First Name", "Last Name", "Phone Number". Please ensure that your contact's names in the csv file are separated into first and last names in their own respective columns.
                    </p>
                    <p>
                        You may have more columns in your csv file than just these three, but without these three columns correctly labeled your contact list will not be uploaded correctly. Please email info@getinca.com for any assistance and we would be happy to help.
                    </p>
                    <Button
                        color="link"
                        onClick={() => window.open("https://docs.google.com/spreadsheets/d/1Dn0i4HOwh1ARq5fo3f9VihJNTENWbpGdV07_vjSkJAA/edit?usp=sharing", "_blank")}
                    >
                        Sample file
                    </Button>
                </CardBody>
            </Card>
            <Card className="mb-4">
              <CardBody>
             

                <InputGroup  style={{justifyContent:"space-around"}}>
                    
                  <Input
                    type="file"
                    id="exampleCustomFileBrowser4"
                    name="customFile"
                    style={{borderRadius:'inherit'}}
                    onChange={fileCapture}
                  />
                  <InputGroupAddon addonType="append">
                    <Button 
                        outline 
                        onClick={() => uploadCSV()} 
                        color="primary"
                        className={`btn-multiple-state ${isLoading ? "" : "show-spinner"}`}
                    >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">Import</span>
                    </Button>
                  </InputGroupAddon>
                </InputGroup>
              </CardBody>
            </Card>
            
          </Fragment>
        ) : (
          <div className="loading" />
        );
    
}
